/* eslint-disable @typescript-eslint/no-explicit-any */
import Script from "next/script";
import Head from "next/head";
import { useCallback, useEffect, useState } from "react";
import { useStore } from "@modules/docvault/state";
import { BoxFile } from "@modules/box/types";

interface IFilePreview {
  files: BoxFile[];
  accessToken?: string;
}

const FilePreview = ({ accessToken, files }: IFilePreview) => {
  const [viewer, setViewer] = useState<any>(null);
  const setPreviewFile = useStore((state) => state.setPreviewFile);
  const setPreviewTopNavFileName = useStore(
    (state) => state.setPreviewTopNavFileName
  );
  const previewFile = useStore((state) => state.previewFile);
  const previewCollection = useStore((state) => state.previewCollection);

  const initializeViewer = useCallback(() => {
    if (window.Box?.Preview) {
      setViewer(new window.Box.Preview());
    }
  }, [setViewer]);

  useEffect(() => {
    if (viewer) {
      viewer.addListener("load", (event: { file: BoxFile }) => {
        setPreviewTopNavFileName(event.file?.name);
      });
      viewer.addListener("navigate", (fileId: BoxFile["id"]) => {
        setPreviewTopNavFileName(
          files?.find((f) => f.id === fileId)?.name ?? ""
        );
      });
    }
    return () => viewer?.removeAllListeners();
  }, [
    files,
    previewFile?.id,
    setPreviewFile,
    setPreviewTopNavFileName,
    viewer,
  ]);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (viewer && accessToken) {
      if (previewFile) {
        viewer.show(previewFile.id, accessToken, {
          container: "#forme-preview-container",
          header: "none",
          collection: previewCollection,
        });
      } else {
        viewer.hide();
      }
    }
  }, [accessToken, viewer, previewFile, previewCollection]);

  useEffect(() => {
    // Resets viewer after page navigation from document vault
    if (window.Box?.Preview && !viewer) {
      initializeViewer();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="safari-only-screen-height flex">
      <Head>
        <link
          href="https://cdn01.boxcdn.net/platform/preview/2.81.0/en-US/preview.css"
          rel="stylesheet"
        />
      </Head>
      <Script
        id="box-preview"
        src="https://cdn01.boxcdn.net/platform/preview/2.81.0/en-US/preview.js"
        onLoad={initializeViewer}
      />
      <div
        id="forme-preview-container"
        className={
          "absolute inset-0 z-20 border-purple-2-500 shadow-sm " +
          (previewFile ? "" : "hidden")
        }
      />
    </div>
  );
};

export default FilePreview;
